module.exports = {"title":"Edenred UK Group Privacy Policy","version":"","lists":{"0":{"title":"","html":"<a target=\"_blank\" href=\"https://www.edenred.co.uk/en/privacy-policy/\">Click here to see the Edenred (UK Group) Limited privacy policy.</a>"}}}


//////////////////
// WEBPACK FOOTER
// ./src/data/pp/pp.json
// module id = 178
// module chunks = 1